import camelcaseKeys from 'camelcase-keys';
import TicketsAPI from 'dashboard/api/tickets';
import { throwErrorMessage } from 'dashboard/store/utils/api';
import { defineStore } from 'pinia';

const camelize = data => camelcaseKeys(data, { deep: true });

const buildFormData = ({ attachments = [], ...fields }) => {
  const formData = new FormData();
  Object.entries(fields).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      formData.append(key, value);
    }
  });
  attachments.forEach(file => formData.append('attachments[]', file));
  return formData;
};

export const useTicketsStore = defineStore('tickets', {
  state: () => ({
    unreadCount: 0,
    ticketTypes: [],
    records: [],
    meta: { count: 0, currentPage: 1, totalPages: 0 },
    uiFlags: { isFetching: false, isCreating: false, isCommenting: false },
  }),

  actions: {
    async fetchSummary() {
      const { data } = await TicketsAPI.summary();
      this.unreadCount = data.unread_count;
      this.ticketTypes = camelize(data.ticket_types);
    },

    async fetchTickets({ status, page = 1 }) {
      this.uiFlags.isFetching = true;
      try {
        const { data } = await TicketsAPI.get({ status, page });
        const tickets = camelize(data.payload);
        this.records = page > 1 ? [...this.records, ...tickets] : tickets;
        this.meta = camelize(data.meta);
        this.unreadCount = data.meta.unread_count;
      } catch (error) {
        throwErrorMessage(error);
      } finally {
        this.uiFlags.isFetching = false;
      }
    },

    async fetchTicket(ticketId) {
      const { data } = await TicketsAPI.show(ticketId);
      const ticket = camelize(data.payload);
      this.markAsRead(ticketId);
      return ticket;
    },

    markAsRead(ticketId) {
      const record = this.records.find(item => item.id === ticketId);
      if (!record?.unread) return;
      record.unread = false;
      this.unreadCount = Math.max(this.unreadCount - 1, 0);
    },

    async createTicket(payload) {
      this.uiFlags.isCreating = true;
      try {
        const { data } = await TicketsAPI.create(buildFormData(payload));
        return camelize(data.payload);
      } finally {
        this.uiFlags.isCreating = false;
      }
    },

    async createComment(ticketId, payload) {
      this.uiFlags.isCommenting = true;
      try {
        const { data } = await TicketsAPI.createComment(
          ticketId,
          buildFormData(payload)
        );
        return camelize(data.payload);
      } finally {
        this.uiFlags.isCommenting = false;
      }
    },
  },
});
